// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-container {\n  display: flex;\n  column-gap: 10px;\n  font-size: 16px;\n  color: #1495e6;\n}\n", ""]);
// Exports
module.exports = exports;
